<template>
  <div class="topup-footer">
    <div class="topup-footer-links">
      <div class="links1">
        <a id="link-terms" :href="getTermsTopupUrl()" target="_blank" rel="noreferrer">{{ $t('component.footer.linkTerms') }}</a>
        <a id="link-invoice" href="https://faktury.autopay.pl" target="_blank" rel="noreferrer">{{ $t('component.footer.linkInvoice') }}</a>
        <a id="link-faq" href="https://www.plus.pl/doladujonline" target="_blank" rel="noreferrer">{{ $t('component.footer.linkFaq') }}</a>
        <a id="register-sim" href="https://zarejestrujnumer-plus.autopay.pl" target="_blank" rel="noreferrer">{{ $t('component.footer.registerSim') }}</a>
      </div>
      <div class="links2">
        <a id="link-terms-auto" :href="getTermsCyclicUrl()" target="_blank">{{ $t('component.footer.linkTermsAuto') }}</a>
        <a v-if="isPolishLang()" id="link-terms-promo-6400" :href="getTerms6400Url()" target="_blank" rel="noreferrer">Regulamin Promocji “Nawet 6400 GB, Plus”</a>
        <a v-if="isPolishLang()" id="link-terms-promo-kumulacja" href="/files/plus/Regulamin_Pakiety_Bez_Limit_kumulacja.pdf" target="_blank" rel="noreferrer">Regulamin Promocji “Pakiety BezLimit kumulacja”</a>
      </div>
    </div>
    <div class="topup-footer-bottom">
      <div class="topup-footer-copyrights" v-html="$t('component.footer.copyrights', {year: year})"></div>
      <ul class="topup-footer-menu">
        <li><a id="link-about" href="https://www.polkomtel.com.pl" target="_blank" rel="noreferrer">{{ $t('component.footer.menu.linkAboutUs') }}</a></li>
        <li><a id="link-contact" href="https://www.plus.pl/kontakt" target="_blank" rel="noreferrer">{{ $t('component.footer.menu.linkContact') }}</a></li>
        <li><a id="link-press" href="https://www.biuroprasowe.plus.pl" target="_blank" rel="noreferrer">{{ $t('component.footer.menu.linkPress') }}</a></li>
        <li><a id="link-news" href="https://www.plus.pl/aktualnosci-i-komunikaty/" target="_blank" rel="noreferrer">{{ $t('component.footer.menu.linkNews') }}</a></li>
        <li><a id="link-job" href="https://www.plus.pl/praca" target="_blank" rel="noreferrer">{{ $t('component.footer.menu.linkJob') }}</a></li>
        <li><a id="link-privacy" href="https://www.plus.pl/polityka-prywatnosci" target="_blank" rel="noreferrer">{{ $t('component.footer.menu.linkPrivacyPolicy') }}</a></li>
        <li><a id="link-site-map" href="https://www.plus.pl/mapa-strony" target="_blank" rel="noreferrer">{{ $t('component.footer.menu.linkSiteMap') }}</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ToolsClass } from '@/common/class/tools.class'
import { LANG } from '@/common/const/lang.const'
import { TERMS_TOPUP_LINKS, TERMS_CYCLIC_LINKS } from '@/plus/const/terms.const'
import { GB6400_PROMO } from '@/plus/const/promo.const'

export default {
  name: 'TopupFooter',
  data () {
    return {
      year: ToolsClass.getCurrentYear()
    }
  },
  methods: {
    isPolishLang () {
      return this.$i18n.locale() === LANG.pl
    },
    getTermsTopupUrl () {
      return TERMS_TOPUP_LINKS[this.$i18n.locale()] || null
    },
    getTermsCyclicUrl () {
      return TERMS_CYCLIC_LINKS[this.$i18n.locale()] || null
    },
    getTerms6400Url () {
      return GB6400_PROMO.regulation
    }
  }
}
</script>

<style src="../assets/scss/footer.scss" lang="scss"></style>
